var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3 d-flex",attrs:{"id":"page"}},[_c('v-img',{staticClass:"page-image",attrs:{"contain":"","position":_vm.getPageImageAlignment,"aspect-ratio":"1","lazy-src":_vm.lazySource,"src":_vm.imageSource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }